import React, { useState, useEffect, useCallback } from 'react';

export default function AutoImageSlider({ images, duration = 5000 }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const goToNextSlide = useCallback(() => {
    setIsTransitioning(true);
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    setTimeout(() => setIsTransitioning(false), 500); // transition duration
  }, [images.length]);

  useEffect(() => {
    const timer = setTimeout(goToNextSlide, duration);
    return () => clearTimeout(timer);
  }, [currentIndex, duration, goToNextSlide]);

  return (
    <div className="auto-slider-wrapper" style={{ width: '100%', maxWidth: '700px', margin: '0 auto' }}>
      {/* Slider container */}
      <div className="slider-container" style={{ position: 'relative', aspectRatio: '16 / 8', overflow: 'hidden', borderRadius: '12px' }}>
        {images.map((item, index) => (
          <div
            key={index}
            className={`slide ${index === currentIndex ? 'active' : ''}`}
            style={{
              position: 'absolute',
              inset: 0,
              opacity: index === currentIndex ? 1 : 0,
              transition: 'opacity 0.5s ease-in-out',
            }}
          >
            <img
              src={item.p_image}
              alt={`Slide ${index + 1}`}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          </div>
        ))}
      </div>

      {/* Dots / progress indicators */}
      <div className="progress-dots" style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginTop: '8px', height: '8px' }}>
        {images.map((_, index) => (
          <div
            key={index}
            className="dot"
            style={{
              width: index === currentIndex ? '64px' : '8px',
              height: '6px',
              borderRadius: '4px',
              backgroundColor: '#9AE6B4', // light green
              overflow: 'hidden',
              transition: 'width 0.3s ease',
            }}
          >
            <div
              style={{
                height: '100%',
                width: '100%',
                backgroundColor: '#38A169', // green
                animation: index === currentIndex ? `progress ${duration}ms linear` : 'none',
              }}
            />
          </div>
        ))}
      </div>

      {/* Animation keyframes */}
      <style>{`
        @keyframes progress {
          from { transform: scaleX(0); transform-origin: left; }
          to { transform: scaleX(1); transform-origin: left; }
        }
      `}</style>
    </div>
  );
}
